/* eslint-disable max-len */
import React from 'react';

function DiscountTooltip({ prod, OrderDetails }) {
    return (
        <div id="tooltip-discountPrice" role="tooltip" className="inline-block absolute z-10 sm:pl-5 sm:pr-4 px-2 pb-2 sm:pt-4 pt-2.5 bg-white rounded-lg shadow-s2 sm:min-w-[200px] w-[200px]">
            <p className="text-xs6 font-semibold text-[#090406]">Offer Applied</p>
            <p className="text-xs13 font-semibold text-[#555259] pt-[3px]">
                {prod?.deal}
                {' '}
                |Criteria-
                {Number(prod?.criteria) + 1}
            </p>
            <div className="flex items-center justify-between pt-2.5">
                <p className="text-sm font-normal text-[#555259]">Trade Discount</p>
                <p className="text-lg font-semibold text-[#555259]">
                    {prod?.trade_discount_type === '₹' ? (['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? Number(prod?.trade_discount_applied || 0) : 0).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) : `${['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? prod?.trade_discount || 0 : 0}%`}
                </p>
            </div>
            <div className="flex items-center justify-between pt-1">
                <p className="text-sm font-normal text-[#555259]">Additional Discount </p>
                <p className="text-lg font-semibold text-[#555259]">
                    {prod?.trade_discount_type === '₹' ? Number(['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? prod?.additinal_discount_applied : prod?.trade_discount_applied || 0).toLocaleString('en-IN', {
                        style: 'currency',
                        currency: 'INR',
                    }) : `${['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? prod?.additinal_discount : prod?.trade_discount || 0}%`}

                </p>
            </div>
            {OrderDetails !== undefined && OrderDetails.order_type === 'Trade EUB'
            && (
                <>
                    <div className="flex items-center justify-between pt-2.5">
                        <p className="text-sm font-normal text-[#555259]">Proposed Discount</p>
                        <p className="text-lg font-semibold text-[#555259]">
                            {prod?.proposed_type === '₹' ? Number(prod?.proposed_total_price || prod?.proposed_total_price || 0).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            }) : `${prod?.proposed_amount || 0}%`}

                        </p>
                    </div>
                    <div className="flex items-center justify-between pt-1">
                        <p className="text-sm font-normal text-[#555259]">Revised Discount </p>
                        <p className="text-lg font-semibold text-[#555259]">
                            {prod?.revised_type === '₹' ? Number(prod?.revised_total_price || prod?.revised_total_price || 0).toLocaleString('en-IN', {
                                style: 'currency',
                                currency: 'INR',
                            }) : `${prod?.revised_price || 0}%`}

                        </p>
                    </div>
                </>
            )}
            <div className="tooltip-arrow" data-popper-arrow />
        </div>
    );
}

export default DiscountTooltip;
